export const KeycloakConstants = {
    SET_LOG_IN: "SET_LOG_IN",
    SET_LOG_OUT: "SET_LOG_OUT",
    SET_LOCATION: "SET_LOCATION",
};
